import CityManagementPage from "./shared/CityManagementPage";
import { cityConfigs } from "./shared/cityConfig";

export default function Liverpool() {
  return <CityManagementPage config={cityConfigs.liverpool} />;
}